module.exports = __webpack_public_path__ + "static/media/banner-primavera.619168ba.png";